import React from 'react';
import { GuestGroupsByDepthKey } from '../Groups/types';
import CreateGuestGroup from './CreateGroup';

export const CreateGroup: React.FunctionComponent = () => <CreateGuestGroup depth={GuestGroupsByDepthKey.GROUPS} />;
export const CreateSection: React.FunctionComponent = () => <CreateGuestGroup depth={GuestGroupsByDepthKey.SECTIONS} />;
export const CreateSubSection: React.FunctionComponent = () => (
    <CreateGuestGroup depth={GuestGroupsByDepthKey.SUB_SECTIONS} />
);
